import { get } from '@aiptyg/api-client';
import type { DashboardOverviewDTO } from '../types/dashboard.types';

export function getAdminDashboardOverview(): Promise<DashboardOverviewDTO> {
  return get<DashboardOverviewDTO>('/v1/admin/dashboard/overview');
}
